/**
 * @flow
 */

import { combineReducers } from 'redux'
import progress from '../features/progress/reducer'
import form from '../features/form/reducer'
import preview from '../features/preview/reducer'
import chat from '../features/ai-chat/reducer'
import resumes from '../features/resumes/reducer'
import type { State, AppAction } from './types'

const combinedReducers = combineReducers({
  progress,
  form,
  preview,
  chat,
  resumes,
})

function rootReducer(state: State | undefined, action: AppAction): State {
  if (action.type === 'CLEAR_STATE') {
    state = undefined
  }

  return combinedReducers(state, action)
}

export default rootReducer
